import React from "react"
import { FlexContainer } from "@carrotfertility/carotene"
import CarrotMarkdown from "utils/CarrotMarkdown"

const wrapper = ({ children }): JSX.Element => (
  <FlexContainer direction="column" gap="small">
    {children}
  </FlexContainer>
)

export const StackedMarkdown = ({ source }: { source: string }): JSX.Element => (
  <CarrotMarkdown source={source} wrapper={wrapper} />
)
